@let sidenav = sidenavContent();
@let title = sidenavTitle();

<div class="flex flex-col w-full h-full overflow-hidden">
  <div class="flex flex-col overflow-hidden w-full h-full p-6">

      <div class="flex justify-between">
        @if (!sidenav?.hideHeader) {
          <div>
            @if (title?.template) {
              <ng-container *ngTemplateOutlet="title.template"></ng-container>
            } @else if (title?.text) {
              <h2 class="m-0 text-dark">{{ title.text }}</h2>
            }
          </div>
        }
        @if (!sidenav?.hideCloseButton) {
        <a href="" class="close-link flex" (click)="onClose($event)">
          <fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
        </a>
        }
      </div>

    @if (sidenav?.template) {
      <ng-template *ngTemplateOutlet="sidenav.template"></ng-template>
    }
  </div>
</div>
